"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CellLinked = _interopRequireDefault(require("./CellLinked"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellWithCheckboxLinked(_ref) {
  var isChecked = _ref.isChecked,
      value = _ref.value,
      id = _ref.id,
      link = _ref.link,
      maxLength = _ref.maxLength,
      onCheck = _ref.onCheck;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "table-cell_checkboxed",
    id: id
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    label: "",
    checked: isChecked,
    onChange: onCheck
  }), /*#__PURE__*/_react.default.createElement(_CellLinked.default, {
    value: value,
    link: link,
    maxLength: maxLength
  }));
}

CellWithCheckboxLinked.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  isChecked: _propTypes.default.bool,
  id: _propTypes.default.number,
  link: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  onCheck: _propTypes.default.func
};
CellWithCheckboxLinked.defaultProps = {
  value: null,
  isChecked: false,
  id: null,
  link: null,
  maxLength: 20,
  onCheck: function onCheck() {}
};
var _default = CellWithCheckboxLinked;
exports.default = _default;